(function () {
  'use strict';
  if (window.ZeptoAddonsLoaded) return;
  window.ZeptoAddonsLoaded = true;
  var dialog, cards = [], tabs = [], busy = false, lastFocused, selectedTab = 'all', mainProductId = 0, excludedCollections = new Set(), popupAdditions = new Map();
  function init() {
    if (dialog) return true;
    dialog = document.getElementById('ZeptoAddonsPopup');
    if (!dialog || typeof dialog.showModal !== 'function') { dialog = null; return false; }
    cards = Array.from(dialog.querySelectorAll('[data-za-card]'));
    tabs = Array.from(dialog.querySelectorAll('[data-za-tab]'));
    var proceed = dialog.querySelector('[data-za-continue]');
    proceed.dataset.emptyLabel = proceed.textContent;
    dialog.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var button = target.closest('button');
      if (button) {
        if (button.hasAttribute('data-za-close') || button.hasAttribute('data-za-shop')) return close();
        if (button.hasAttribute('data-za-continue') || button.hasAttribute('data-za-skip')) return finish();
        if (button.hasAttribute('data-za-tab')) return filter(button.dataset.zaTab);
        var card = button.closest('[data-za-card]');
        if (card && (button.hasAttribute('data-za-add') || button.hasAttribute('data-za-plus') || button.hasAttribute('data-za-minus'))) {
          return change(card, button.hasAttribute('data-za-minus') ? -1 : 1);
        }
      }
      if (target === dialog) {
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }
    });
    dialog.addEventListener('change', function (event) {
      if (event.target.matches('[data-za-variant]')) sync();
    });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('zepto-addons-open');
      if (lastFocused && lastFocused.isConnected) lastFocused.focus();
    });
    dialog.querySelector('[role=tablist]').addEventListener('keydown', function (event) {
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      var visible = tabs.filter(function (tab) { return !tab.hidden; });
      var index = visible.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      index = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 :
        (index + (event.key === 'ArrowRight' ? 1 : -1) + visible.length) % visible.length;
      filter(visible[index].dataset.zaTab);
      visible[index].focus();
    });
    if (window.ZeptoATC) window.ZeptoATC.subscribe(sync);
    return true;
  }
  function available() { return init() && cards.some(function (card) { return card.querySelector('[data-za-variant]').options.length > 0; }); }
  function eligibleCard(card) {
    var productId = Number(card.dataset.productId);
    return productId !== mainProductId &&
      !excludedCollections.has(card.dataset.zaCollection) &&
      !cards.some(function (candidate) {
        return Number(candidate.dataset.productId) === productId && excludedCollections.has(candidate.dataset.zaCollection);
      });
  }
  function addedProductCollections(context) {
    var source = context.source && context.source.closest ? context.source.closest('[data-product-id][data-za-collections]') : null;
    if (!source || Number(source.dataset.productId) !== mainProductId) {
      source = document.querySelector('[data-product-id="' + mainProductId + '"][data-za-collections]');
    }
    var handles = source && source.dataset.zaCollections ? source.dataset.zaCollections.split(',').filter(Boolean) : [];
    var configured = new Set(tabs.map(function (tab) { return tab.dataset.zaCollection; }).filter(Boolean));
    return new Set(handles.filter(function (handle) { return configured.has(handle); }));
  }
  function filter(category) {
    selectedTab = category;
    var seen = new Set();
    cards.forEach(function (card) {
      var eligible = eligibleCard(card) && (category === 'all' || card.dataset.category === category);
      card.hidden = !eligible || seen.has(card.dataset.productId);
      if (!card.hidden) seen.add(card.dataset.productId);
    });
    tabs.forEach(function (tab) {
      var selected = tab.dataset.zaTab === category;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    dialog.querySelector('[role=tabpanel]').setAttribute('aria-labelledby', 'za-tab-' + category);
  }
  function sync() {
    if (!dialog || !window.ZeptoATC) return;
    cards.forEach(function (card) {
      var select = card.querySelector('[data-za-variant]');
      var qty = window.ZeptoATC.quantityOf(select.value);
      card.querySelector('[data-za-add]').hidden = qty > 0;
      card.querySelector('[data-za-qty]').hidden = qty === 0;
      card.querySelector('[data-za-count]').textContent = qty;
      card.querySelector('[data-za-price]').textContent = window.ZeptoATC.money(Number(select.selectedOptions[0].dataset.price));
    });
    updateAddonCount();
  }
  function updateAddonCount() {
    var count = 0;
    popupAdditions.forEach(function (quantity, id) {
      count += Math.min(quantity, window.ZeptoATC.quantityOf(id));
    });
    var button = dialog.querySelector('[data-za-continue]');
    button.textContent = count ? 'Confirm • ' + count + (count === 1 ? ' addon' : ' addons') : button.dataset.emptyLabel;
  }
  function error(message) {
    var element = dialog.querySelector('[data-za-error]');
    element.textContent = message || '';
    element.hidden = !message;
  }
  function setBusy(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('[data-za-add],[data-za-minus],[data-za-plus],[data-za-variant],[data-za-continue],[data-za-skip]').forEach(function (element) { element.disabled = value; });
  }
  function open(context) {
    if (!available()) return window.ZeptoATC.openDrawer();
    mainProductId = Number(context.productId) || 0;
    excludedCollections = addedProductCollections(context);
    if (!cards.some(eligibleCard)) return window.ZeptoATC.openDrawer();
    if (!dialog.open) popupAdditions.clear();
    lastFocused = document.activeElement;
    dialog.querySelector('[data-za-added]').textContent = context.title ? context.title + ' added to your bag' : 'Added to your bag';
    tabs.forEach(function (tab) {
      if (tab.dataset.zaTab === 'all') return;
      tab.hidden = excludedCollections.has(tab.dataset.zaCollection) || !cards.some(function (card) {
        return card.dataset.category === tab.dataset.zaTab && eligibleCard(card);
      });
    });
    var firstTab = tabs.find(function (tab) { return !tab.hidden; });
    if (!firstTab) return window.ZeptoATC.openDrawer();
    error(''); filter(firstTab.dataset.zaTab); sync();
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('zepto-addons-open');
  }
  function close() { if (dialog && dialog.open) dialog.close(); }
  function change(card, delta) {
    if (busy || !window.ZeptoATC) return;
    var select = card.querySelector('[data-za-variant]'), id = Number(select.value);
    var qty = window.ZeptoATC.quantityOf(id);
    var option = select.selectedOptions[0];
    var min = Number(option.dataset.min) || 1, step = Number(option.dataset.step) || 1;
    var target = delta > 0 ? (qty ? qty + step : min) : (qty - step < min ? 0 : qty - step);
    var line = window.ZeptoATC.lineOf(id);
    setBusy(true); error('');
    var request = line ? window.ZeptoATC.change(line.key, target) : window.ZeptoATC.add(id, target);
    request.then(function () { return window.ZeptoATC.refresh(); })
      .then(function (cart) {
        if (!cart) throw new Error('Unable to confirm your bag. Please try again.');
        var actual = window.ZeptoATC.quantityOf(id);
        var added = popupAdditions.get(id) || 0;
        // Count only units added in this popup session; remove those units first.
        popupAdditions.set(id, Math.max(0, added + actual - qty));
        window.ZeptoATC.notify(false); sync();
      })
      .catch(function (err) { error(err.message || 'Unable to update your bag. Please try again.'); })
      .finally(function () { setBusy(false); });
  }
  function finish() {
    if (busy || !window.ZeptoATC) return;
    setBusy(true); error('');
    window.ZeptoATC.refresh().then(function (cart) {
      if (!cart) throw new Error('Unable to refresh your bag. Please try again.');
      close();
      return window.ZeptoATC.openDrawer();
    }).catch(function (err) {
      if (!dialog.open) { dialog.showModal(); document.documentElement.classList.add('zepto-addons-open'); }
      error(err.message || 'Unable to open your bag. Please try again.');
    }).finally(function () { setBusy(false); });
  }
  var confirmation, confirmationBusy = false, popupTimer = null;
  function cancelScheduledPopup() { clearTimeout(popupTimer); popupTimer = null; }
  function fly(context) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return Promise.resolve();
    var source = context.source;
    var card = source && source.closest ? source.closest('.m-product-card, .m-product-item, .dn-svs__card') || (source.parentElement && source.parentElement.closest('[data-product-id]')) : null;
    var image = (card && card.querySelector('img')) || (source && source.querySelector && source.querySelector('img'));
    var targets = Array.from(document.querySelectorAll('[data-zepto-cart-target], .m-header__cart, .m-cart-icon, [aria-controls="cart-drawer"], [data-open-cart], a[href$="/cart"]'));
    function visible(element) { var rect = element.getBoundingClientRect(); return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight; }
    var target = targets.find(visible);
    if (!image || !target || !visible(image) || typeof image.animate !== 'function') return Promise.resolve();
    var from = image.getBoundingClientRect(), to = target.getBoundingClientRect();
    var size = Math.min(110, from.width, from.height);
    var startX = from.left + (from.width - size) / 2, startY = from.top + (from.height - size) / 2;
    var dx = to.left + to.width / 2 - startX - size / 2, dy = to.top + to.height / 2 - startY - size / 2;
    var clone = document.createElement('img');
    clone.src = image.currentSrc || image.src;
    clone.alt = ''; clone.setAttribute('aria-hidden', 'true');
    clone.className = 'zepto-cart-flight';
    Object.assign(clone.style, {left: startX + 'px', top: startY + 'px', width: size + 'px', height: size + 'px'});
    document.body.appendChild(clone);
    return new Promise(function (resolve) {
      var done = false, timer;
      function finish() { if (done) return; done = true; clearTimeout(timer); clone.remove(); resolve(); }
      try {
        var motion = clone.animate([
          {transform: 'translate(0, 0) scale(1)', opacity: 1},
          {transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - 60) + 'px) scale(.75)', opacity: .95, offset: .45},
          {transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.12)', opacity: 0}
        ], {duration: 700, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards'});
        motion.onfinish = function () {
          try { target.animate([{transform:'scale(1)'},{transform:'scale(1.18)'},{transform:'scale(1)'}], {duration:260, easing:'ease-out'}); } catch (e) {}
          finish();
        };
        motion.oncancel = finish;
        timer = setTimeout(finish, 850);
      } catch (e) { finish(); }
    });
  }
  function combined(context) {
    cancelScheduledPopup();
    confirm();
    fly(context);
    popupTimer = setTimeout(function () {
      popupTimer = null;
      if (!available()) return;
      confirmation.hidden = true;
      open(context);
    }, 1000);
  }
  function confirm() {
    if (!confirmation) {
      var template = document.getElementById('ZeptoConfirmationTemplate');
      if (template) {
        document.body.appendChild(template.content.cloneNode(true));
        confirmation = document.querySelector('.zepto-confirmation');
      } else {
        confirmation = document.createElement('div');
        confirmation.className = 'zepto-confirmation';
        confirmation.setAttribute('role', 'status');
        confirmation.innerHTML = '<span class="zepto-confirmation__check" aria-hidden="true">✓</span><span>Product Added To Cart!</span><button type="button" data-za-view-cart>View Cart</button><button type="button" data-za-dismiss aria-label="Close">×</button>';
        document.body.appendChild(confirmation);
      }
      confirmation.querySelector('[data-za-dismiss]').addEventListener('click', function () { cancelScheduledPopup(); confirmation.hidden = true; });
      confirmation.querySelector('[data-za-view-cart]').addEventListener('click', function () {
        if (confirmationBusy) return;
        cancelScheduledPopup();
        close();
        confirmationBusy = true;
        var button = confirmation.querySelector('[data-za-view-cart]');
        button.disabled = true;
        window.ZeptoATC.refresh().then(function (cart) {
          if (!cart) throw new Error('Unable to refresh your bag. Please try again.');
          return window.ZeptoATC.openDrawer();
        }).then(function () { confirmation.hidden = true; })
          .catch(function (err) { button.title = err.message; confirmation.setAttribute('role', 'alert'); })
          .finally(function () { confirmationBusy = false; button.disabled = false; });
      });
    }
    confirmation.hidden = false;
  }
  window.ZeptoAddons = { available: available, open: open, close: close, confirm: confirm, combined: combined, fly: fly };
})();

